import camera from './camera';
import planet from './planet';

export default {camera, planet};


// WEBPACK FOOTER //
// ./src/apps/scene-planet/reducers/index.js